module.exports = __webpack_public_path__ + "img/home-block-4.a9e13da0.png";